import { Trans } from "@lingui/react/macro";

type TotalMetricCardProps = {
  metricLabel: string;
  value: string;
};

export function TotalMetricCard({ metricLabel, value }: TotalMetricCardProps) {
  return (
    <div className="rounded-xl border bg-card p-6 shadow-sm">
      <div className="text-sm text-muted-foreground">
        <Trans>Total {metricLabel}</Trans>
      </div>
      <div className="mt-2 text-3xl font-semibold tabular-nums">{value}</div>
    </div>
  );
}
